import React from 'react';
import PropTypes from 'prop-types';

// import assets
import './socialMediaDropDown.scss';

import '../../../../../assets/icons/Icon_YouTube_Black.svg';
import '../../../../../assets/icons/Icon_Vimeo.svg';
import '../../../../../assets/icons/Icon_Facebook.svg';
import '../../../../../assets/icons/Icon_Twitter.svg';
import '../../../../../assets/icons/Icon_Instagram.svg';
import '../../../../../assets/icons/Icon_GPlus.svg';
import '../../../../../assets/icons/Lenspire_Icon_ArrowDropdownHeader.svg';

const SocialMediaDropDown = (props) => {
  let fb = null;
  let twitter = null;
  let yt = null;
  let vimeo = null;
  let instagram = null;
  let google = null;
  if (props.channels.fb !== '') {
    fb =
      (<li className="m-social-media-dropdown__list-item">
        <a href={props.channels.fb} target="_blank" rel="noopener" className="m-social-media-dropdown__icon">
          <span className="m-social-media-dropdown__icon-circle">
            <svg>
              <use xlinkHref="#Icon_Facebook" />
            </svg>
          </span>
        </a>
      </li>);
  }
  if (props.channels.twitter !== '') {
    twitter = (<li className="m-social-media-dropdown__list-item">
      <a href={props.channels.twitter} target="_blank" rel="noopener" className="m-social-media-dropdown__icon">
        <span className="m-social-media-dropdown__icon-circle">
          <svg>
            <use xlinkHref="#Icon_Twitter" />
          </svg>
        </span>
      </a>
    </li>);
  }
  if (props.channels.yt !== '') {
    yt =
      (<li className="m-social-media-dropdown__list-item">
        <a href={props.channels.yt} target="_blank" rel="noopener" className="m-social-media-dropdown__icon">
          <span className="m-social-media-dropdown__icon-circle">
            <svg>
              <use xlinkHref="#Icon_YouTube_Black" />
            </svg>
          </span>
        </a>
      </li>);
  }
  if (props.channels.vimeo !== '') {
    vimeo =
      (<li className="m-social-media-dropdown__list-item">
        <a href={props.channels.vimeo} target="_blank" rel="noopener" className="m-social-media-dropdown__icon">
          <span className="m-social-media-dropdown__icon-circle">
            <svg>
              <use xlinkHref="#Icon_Vimeo" />
            </svg>
          </span>
        </a>
      </li>);
  }
  if (props.channels.instagram !== '') {
    instagram =
      (<li className="m-social-media-dropdown__list-item">
        <a href={props.channels.instagram} target="_blank" rel="noopener" className="m-social-media-dropdown__icon">
          <span className="m-social-media-dropdown__icon-circle">
            <svg>
              <use xlinkHref="#Icon_Instagram" />
            </svg>
          </span>
        </a>
      </li>);
  }
  if (props.channels.google !== '') {
    google =
      (<li className="m-social-media-dropdown__list-item">
        <a href={props.channels.google} target="_blank" rel="noopener" className="m-social-media-dropdown__icon">
          <span className="m-social-media-dropdown__icon-circle">
            <svg>
              <use xlinkHref="#Icon_GPlus" />
            </svg>
          </span>
        </a>
      </li>);
  }

  return (
    <div className="m-social-media-dropdown">
      <p>{props.text}</p>
      <ul className="m-social-media-dropdown__list">
        {fb}
        {twitter}
        {yt}
        {vimeo}
        {instagram}
        {google}
      </ul>
      <span className="m-social-media-dropdown__arrow">
        <svg>
          <use xlinkHref="#Lenspire_Icon_ArrowDropdownHeader" />
        </svg>
      </span>
    </div>
  );
};

SocialMediaDropDown.propTypes = {
  text: PropTypes.string,
  channels: PropTypes.shape({
    yt: PropTypes.string,
    vimeo: PropTypes.string,
    fb: PropTypes.string,
    twitter: PropTypes.string,
    instagram: PropTypes.string,
    google: PropTypes.string,
  }),
};

SocialMediaDropDown.defaultProps = {
  text: '',
  channels: {
    yt: '',
    vimeo: '',
    fb: '',
    twitter: '',
    instagram: '',
    google: '',
  },
};

export default SocialMediaDropDown;




// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Header/SocialMediaDropDown/SocialMediaDropDown.jsx